import { EventEmitter } from '@angular/core';
var DropZoneDirective = /** @class */ (function () {
    function DropZoneDirective() {
        this.dropped = new EventEmitter();
        this.hovered = new EventEmitter();
    }
    DropZoneDirective.prototype.onDrop = function ($event) {
        $event.preventDefault();
        this.dropped.emit($event.dataTransfer.files);
        this.hovered.emit(false);
    };
    DropZoneDirective.prototype.onDragOver = function ($event) {
        $event.preventDefault();
        this.hovered.emit(true);
    };
    DropZoneDirective.prototype.onDragLeave = function ($event) {
        $event.preventDefault();
        this.hovered.emit(false);
    };
    return DropZoneDirective;
}());
export { DropZoneDirective };
